export default {"src":"/_next/static/media/ltdins.e66a5061.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};